/** Map share of the split view's width: never so narrow a pane is useless. */
export const SPLIT_MIN = 0.25;
export const SPLIT_MAX = 0.75;
export const SPLIT_DEFAULT = 0.5;
export const clampRatio = (r: number) => Math.min(SPLIT_MAX, Math.max(SPLIT_MIN, r));
